<form
  class="max-w-screen-xl"
  nz-form
  nzLayout="vertical"
  [formGroup]="metaDataForm"
  (ngSubmit)="metaDataSubmit()"
>
  <formly-form
    #formlyForm
    [form]="metaDataForm"
    [fields]="metaDataFields"
    [model]="metaDataModel"
  >
    <ng-template let-field formlyTemplate="placeholder">
      <app-alert
        data-test-id="placeholder"
        class="my-8 block"
        type="notice"
        size="large"
        [showIcon]="true"
      >
        <div alertTitle>
          {{
            'pages.uploadFile.steps.metadata.fields.placeholder.title'
              | translate
          }}
        </div>
        <div
          alertBody
          class="prose prose-sm"
          [innerHTML]="
            'pages.uploadFile.steps.metadata.fields.placeholder.body'
              | translate
              | markdown
              | async
          "
        ></div>
      </app-alert>
    </ng-template>
  </formly-form>

  <div class="flex justify-between">
    <app-button data-test-id="cancelMetaData" type="outline" routerLink="../"
      >{{ 'pages.uploadFile.cancelButton.label' | translate }}
    </app-button>
    <app-button data-test-id="submitMetaData" type="primary" htmlType="submit"
      >{{ 'pages.uploadFile.steps.metadata.next' | translate }}
    </app-button>
  </div>
</form>
